import React from "react";
import {
    EuiAccordion,
    EuiBadge,
    EuiContextMenu,
    EuiFlexGroup,
    EuiOverlayMask,
    EuiPanel,
    EuiStepsHorizontal,
} from "@elastic/eui";
import styled from "styled-components";

export const TripSectionWrapper = styled.div`
    padding: 45px;

    & h3 {
        font-weight: bold;
        margin-bottom: 25px;
        font-size: 18px;
    }

    .trip-section__icon {
        margin-inline-end: 10px;
    }

    .trip-section__content {
        width: calc(100% - 34px);
    }

    .euiAccordion__iconWrapper {
        margin-right: 18px;
        margin-left: 0;
    }

    .euiAccordion__childWrapper {
        background-color: ${(props) => props.theme.default.euiColorLightestShade};

        & > div > div {
            padding: 10px 0;
        }
    }

    .euiAccordion.euiAccordion-isOpen .euiAccordion__childWrapper {
        margin: 0 -35px 0 -36px;
    }

    .euiAccordion__button {
        margin-bottom: 14px;
    }

    .dropoff__section-wrapper {
        padding: 10px 0px;
        padding-left: 60px;
    }

    .dropoff__section-wrapper::last-of-type {
        padding-top: 0;
    }

    .euiAccordion__triggerWrapper button {
        font-weight: 500;
    }

    @media (max-width: 768px) {
        padding: 45px 20px;
        .euiAccordion.euiAccordion-isOpen .euiAccordion__childWrapper {
            margin: 0 -20px 0 -21px;
        }

        h3 {
            margin-bottom: 20px;
        }

        .dropoff__section-wrapper {
            padding-left: 60px;
        }
    }
`;

export const TripSectioDescriptionWrapper = styled.div`
    & {
        ${(props) => props.isIconSection && "margin-left: -33px"}
    }

    @media only screen and (max-width: 768px) {
        ${(props) => (props.isIconSection || props.isActivitySection) && "margin-left: -33px;"}
    }
`;

export const TripActivityContent = styled.div`
    line-height: 2.5;

    @media only screen and (max-width: 768px) {
        & {
            font-size: 13px;
            line-height: 30px;
        }
        .euiAvatar--m {
            width: 25px;
            height: 25px;
            line-height: 25px;
            font-size: 12px;
        }
    }
`;

export const TripStepDetails = styled.div`
    width: 100%;
    overflow: auto;
    max-height: 80vh;
    padding: 10px;
    max-height: 80vh;

    .euiSteps {
        width: 100%;
    }

    .euiStepNumber {
        background-color: ${(props) => props.theme.default.euiColorVis0};
    }

    .euiStep__content {
        color: transparent;
        padding: 0;
    }

    .euiStepHorizontal::before,
    .euiStepHorizontal::after {
        height: 2px;
        background-color: ${(props) => props.theme.default.euiColorLightShade};
    }
`;

export const TripHeader = styled(EuiFlexGroup)`
    background-color: ${(props) => props.theme.default.darkestShade};
    color: ${(props) => props.theme.default.euiTextColor};
    padding: 0 20px;

    .trip-header-content {
        flex-wrap: wrap;
    }

    .trip-header__icon-container {
        margin-inline-end: 10px;
    }

    .trip-header__title-container {
        margin-inline-end: 20px;
        align-items: center;
        flex-direction: row;
    }

    @media only screen and (max-width: 768px) {
        #trip__actions--dottes {
            position: absolute;
            top: 11px;
            right: 20px;
            width: auto !important;
        }
    }

    .trip-header__title {
        white-space: nowrap;
        margin-inline-end: 10px;
        font-size: 22px;
        font-weight: bold;
        color: white;
        margin-right: 10px;
        margin-top: 3px;

        svg {
            margin-top: -3px;
            margin-right: 4px;
        }
    }

    .trip-header_duplicate-button {
        border-style: solid;
        border-color: white;
        border-width: 1px;
        color: white;
        background-color: transparent;
    }

    @media only screen and (max-width: 768px) {
        padding: 20px;

        h2 {
            font-size: 24px;
        }
    }
`;

export const TripHeaderSteps = styled(({ hidePoints, ...rest }) => (
    <EuiStepsHorizontal {...rest} />
))`
    background-color: transparent !important;

    .euiStepHorizontal {
        cursor: default;
    }

    .euiStepNumber {
        background-color: ${(props) => props.theme.default.euiColorVis0};
        color: white !important;
    }

    .euiStepHorizontal:hover:not(.euiStepHorizontal-isDisabled) .euiStepHorizontal__title {
        text-decoration: none;
    }

    .euiStepHorizontal::before,
    .euiStepHorizontal::after {
        height: 2px;
        background-color: white;
    }

    .euiStepHorizontal-isComplete::before,
    .euiStepHorizontal-isComplete::after {
        background-color: ${(props) => props.theme.default.euiColorVis0};
    }

    .euiStepNumber.euiStepNumber--incomplete {
        border-color: white;
    }

    .euiStepHorizontal__title {
        color: white;
        font-weight: bold;
        display: flex;
        padding: 0;
    }

    ${(props) =>
        props.hidePoints &&
        `
        .euiStepHorizontal__item {
            display: none;
        }

        .euiStepHorizontal__item:first-child,
        .euiStepHorizontal__item:nth-child(2),
        .euiStepHorizontal__item:last-child {
            display: flex;
        }
    `}

    @media only screen and (max-width: 768px) {
        .euiStepHorizontal__title {
            font-size: 12px;
            line-height: 1.3;
        }

        .euiStepHorizontal {
            padding: 0;
            padding-top: 5px;
        }

        .euiStepNumber {
            width: 25px;
            height: 25px;
            font-size: 12px;
            line-height: 25px;
        }

        .euiStepHorizontal:before,
        .euiStepHorizontal:after {
            top: 15px;
        }
    }
`;

export const TripHeaderPanel = styled(EuiPanel)`
    background-color: hsl(192deg 76% 24%) !important;
    position: relative;
`;
export const TripWrapper = styled.div`
    margin-top: 30px;
    .euiTab {
        padding: 15px 40px;
        font-weight: bold;
    }

    .euiTab:focus {
        background: initial;
    }

    .hero {
        background: black;
    }
    .euiTab__content {
        font-size: 16px;
    }

    @media only screen and (min-width: 768px) {
        .trip-details-container {
            border-inline-end: 1px solid ${(props) => props.theme.default.euiColorLightShade};
        }
    }
`;

export const TripStepsFormWrapper = styled.div`
    max-width: 900px;

    .euiStep__circle.euiStepNumber--complete {
        background-color: ${(props) => props.theme.default.euiColorVis0};
    }

    .euiStep__circle.euiStepNumber--danger {
        background-color: ${(props) => props.theme.default.euiColorVis9};
    }

    .step-container {
        position: relative;
    }

    .euiStep__content {
        padding: 5px 5px 0 40px;
        margin: 10px 0;
    }

    .dropdown-container--location {
        min-width: 250px;
    }

    .dropoff-form__add-button {
        margin-top: -8px;

        :disabled {
            cursor: not-allowed;
            background-color: gray !important;
            color: white !important;
        }
    }

    .dropoff-form__delete-btn {
        position: absolute;
        top: -45px;
        right: 0;
    }

    .euiStep {
        padding: 10px 0;
    }

    .euiStep.add-step {
        display: flex;

        .euiStepNumber {
            border: none;
        }

        .euiStep__content {
            margin: 0;
            padding: 0;
        }
    }

    @media only screen and (max-width: 768px) {
        .dropdown-container--city,
        .dropdown-container--location {
            min-width: 100%;
        }

        .euiStep__content {
            padding-bottom: 10px;
        }
    }
`;

export const TripTableWrapper = styled.div`
    table {
        border-collapse: separate;
        border-spacing: 0 20px;
        background: transparent;
    }

    tr {
        background-color: ${(props) => props.theme.default.euiColorEmptyShade};
        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.0583206);
        border-radius: 4px;
    }

    thead tr {
        background: transparent;
        box-shadow: none;
    }

    thead th {
        color: #6d6d6d;
    }

    td,
    th {
        padding: 5px 10px;
    }

    td,
    td span,
    .euiTableCellContent--overflowingContent {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    td .euiToolTipAnchor {
        display: flex;
    }

    th {
        padding-top: 0;
        padding-bottom: 0;
    }

    tr td:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-left: 1px solid ${(props) => props.theme.default.euiColorLightShade};
    }

    tr td:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        border-right: 1px solid ${(props) => props.theme.default.euiColorLightShade};
    }

    .trip-table__group-title {
        text-transform: capitalize;
        white-space: nowrap;
    }

    .euiTableFooterCell,
    .euiTableHeaderCell {
        border: none;
    }

    @media only screen and (max-width: 768px) {
        .euiTableRowCell--hasActions {
            padding: 0;

            .euiTableRowCell__mobileHeader {
                display: none;
            }
        }
    }
`;

export const TripCellLoadingContentWrapper = styled.span`
    width: 100%;
    ${(props) =>
        props.blockContent &&
        `
            min-height: 63px;
            display: flex;
            align-items: center;
            justify-content: center;
            
            .euiLoadingContent{
                width: 100%;
            }
    `}

    .euiLoadingContent__singleLine {
        margin: 0;
    }
`;

export const StyledOverlayMask = styled(EuiOverlayMask)`
    flex-direction: column;
    padding: 10px;
    background: ${(props) => props.theme.default.euiColorEmptyShade} !important;
`;

export const DropOffDetailsOverlayWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    width: 100%;
    max-width: 600px;
    margin: 0 auto;

    .dropOffDetailsOverlay__header {
        margin-bottom: 10px;
    }

    button {
        align-self: flex-end;
    }
`;

export const StyledBadge = styled(({ textColor, borderColor, fullWidth, ...rest }) => (
    <EuiBadge {...rest} />
))`
    text-transform: capitalize;
    font-weight: 400;

    ${(props) => props.fullWidth && `width: 100%; text-align: center;`}
    ${(props) => props.borderColor && `border: 1px solid ${props.borderColor};`}
    ${(props) => props.textColor && `span { color: ${props.textColor}; }`}
`;

export const TripActivityWrapper = styled.div`
    overflow-y: auto;
    overflow-x: hidden;
    padding: 10px 0;

    .activity__line {
        margin-bottom: 20px;
    }

    .activity__date {
        margin-inline-end: 25px;
        min-width: 120px;
    }

    @media only screen and (max-width: 767px) and (min-width: 575px) {
        .tripActivityDate {
            margin-bottom: 0 !important;
        }
    }

    @media only screen and (max-width: 574px) {
        .tripActivityDate {
            margin-bottom: 0 !important;
        }
    }
`;

export const TripPoinstCellWrapper = styled.div`
    width: 100%;

    .points-cell__pickup-arrow {
        padding-inline-start: 10px;
        padding-inline-end: 5px;
        display: inline-block;
        flex-shrink: 0;
    }

    .points-cell__pickup-address {
        margin: 0 5px;
    }

    .points-cell__pickup-date {
        unicode-bidi: plaintext;
    }

    .points-cell__dropoffs {
        margin-top: 10px;
        display: inline-flex;
        align-items: center;
        width: 100%;
    }

    .points-cell__dropoffs-content {
        display: inline-flex;
        align-items: center;
    }

    .points-cell__dropoff {
        display: inline-flex;
        align-items: center;
    }

    ${(props) =>
        props.hidePoints &&
        `
        .points-cell__dropoff {
            display: none;
        }

        .points-cell__dropoff:first-child,
        .points-cell__dropoff:nth-child(2),
        .points-cell__dropoff:last-child {
            display: flex;
        }
    `}

    .points-cell__dropoff-arrow {
        margin: 0 3px;
        display: inline-flex;
        flex-shrink: 0;
    }

    .points-cell__point-completed-container {
        margin-inline-end: 3px;
        flex-shrink: 0;
    }
`;

export const TripDropOffWrapper = styled.div`
    .dropoff-section-container__icon {
        margin-inline-end: 10px;
    }
`;

export const StyledAccordion = styled(({ marginBottom, ...props }) => <EuiAccordion {...props} />)`
    ${(props) => (props.marginBottom ? "margin-bottom: 15px;" : "")}
`;

export const DocumentsModalWrapper = styled(EuiOverlayMask)`
    .euiListGroupItem__label {
        display: block;
        width: 100%;
    }

    .documents-modal__item-serial,
    .documents-modal__item-title {
        width: 50%;
    }

    .documents-modal__item-title {
        display: flex;
        justify-content: center;
        padding-right: 15px;

        span {
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }
`;
export const TripActionsContextMenuWrapper = styled(EuiContextMenu)`
    .euiContextMenuItem:last-of-type {
        border-top: 1px solid ${(props) => props.theme.default.euiColorLightShade};
    }
`;


export const CancelTripWrapper = styled.div`
    padding: 16px;
    background: rgb(253, 241, 240) !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: rgb(146, 0, 0);
    border-right: 2px solid red;
    border-left: 2px solid red;
    border-radius: 6px
`

export const CancellationReasonWrapper = styled.div`
display: flex;
margin-top: 10px
`

export const infoIconStyles = {
    marginRight: '10px'
}